module.exports = __webpack_public_path__ + "img/palatine_b4.c59f3709.jpg";